/**
 * A tela é estreita (menos de 1160 px: celular, tablet e notebook pequeno)? Na sala ampliada não há largura para o
 * painel da chamada ao lado do vídeo sem espremer o vídeo: com o painel de 380 px aberto e os espaços entre os dois
 * cartões, o vídeo ficaria com pouco mais da metade da janela, e os controles (cerca de 560 px, centralizados na janela
 * toda, com o botão do painel no canto direito) ficariam por baixo de um vídeo estreito demais. Estreita: o painel vira
 * uma folha entre o vídeo e a barra, e a barra usa o tamanho compacto. A sala ampliada só existe na guia do atendente
 * (a janela flutuante é sempre compacta), então a janela consultada é a da guia.
 */
import { useSyncExternalStore } from 'react';

export const NARROW_QUERY = '(max-width: 1159px)';

const mediaQuery = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(NARROW_QUERY) : null);

const subscribe = (notify) => {
    const query = mediaQuery();
    if (!query) return () => {};
    query.addEventListener?.('change', notify);
    return () => query.removeEventListener?.('change', notify);
};

const snapshot = () => mediaQuery()?.matches ?? false;

/** @returns {boolean} */
export function useNarrowScreen() {
    return useSyncExternalStore(subscribe, snapshot, () => false);
}
